import React, { ReactChild, ReactChildren, FC } from 'react'
import style from './Container.module.scss'
import classnames from 'classnames'

interface ContainerProps {
  children: ReactChild | ReactChildren | JSX.Element | Element | JSX.Element[] | React.ReactNode
  className?: string
  portalClassName?: string
}

const Container: FC<ContainerProps> = ({ children, className, portalClassName }) => <div className={classnames(style['Container'], className, style[portalClassName])}>
  {children}
</div>

export default Container
